import React, { Component } from 'react';
import { TextField } from 'rmwc/TextField';
import { Button } from 'rmwc/Button';
import PlacesAutoComplete from 'react-places-autocomplete'

class EducationItemForm extends Component {
  constructor(props) {
    super(props)

    this.handleDeleteEducation = this.handleDeleteEducation.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleInstitutionChange = this.handleInstitutionChange.bind(this)
  }

  handleDeleteEducation(evt) {
    this.props.handleDelete(this.props.educationDetails.id)
  }

  handleChange(evt) {
    var id = this.props.educationDetails.id
    this.props.onFormChange(evt, id)
  }

  handleInstitutionChange(val){
    var id = this.props.educationDetails.id
    this.props.onFormInstitutionChange(val, id)
  }

  render() {
    return (<div>
      <form onSubmit={this.props.onFormSubmit}>
      <div><input type="hidden" name="id" value={this.props.educationDetails.id} onChange={this.handleChange}/></div>

      <PlacesAutoComplete
          value={this.props.educationDetails.institution}
          onChange={this.handleInstitutionChange}
          >
          {({ getInputProps, suggestions, getSuggestionItemProps }) => (
          <div>
            <TextField
              {...getInputProps({
                placeholder: 'Institution',
                className: 'location-search-input'
              })}
              name="institution"
            />
            <div className="autocomplete-dropdown-container">
              {suggestions.map(suggestion => {
                const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                            ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                return (
                  <div {...getSuggestionItemProps(suggestion, { className, style })}>
                    <span>{suggestion.description}</span>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </PlacesAutoComplete>      

      <TextField label="Degree" autoComplete="off"  name="degree" onChange={this.handleChange} defaultValue={this.props.educationDetails.degree}  />

     <TextField label="Year Of Graduation" autoComplete="off"  name="year_of_graduation" onChange={this.handleChange} defaultValue={this.props.educationDetails.year_of_graduation} />

     <TextField label="City" autoComplete="off"  name="city" onChange={this.handleChange} defaultValue={this.props.educationDetails.city}  />

     <span><Button raised style={{ width: '50%' }}>Save</Button>
      <Button style={{ width: '50%' }} onClick={this.props.onFormClose}>Cancel</Button></span>
      </form>
    </div>)
  }
}

export default EducationItemForm



// WEBPACK FOOTER //
// ./src/views/EducationItemForm.jsx